module.exports = __webpack_public_path__ + "static/media/informacion.84f84b43.svg";